import { css } from '@/styled-system/css';

export const moduleContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  width: '100%',
});

export const mapSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const mapContainer = css({
  width: '100%',
  height: '5000',
  borderRadius: 'md',
  overflow: 'hidden',
  background: 'bg.softest',
  position: 'relative',
  lg: {
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- fixed desktop mini-map viewport height
    height: '240px',
  },
});

export const fallbackContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  background: 'bg.softest',
  color: 'text.subtle',
  padding: 'default',
  textAlign: 'center',
});

export const fallbackIcon = css({
  fontSize: '2xl',
  marginBottom: 'tighter',
  opacity: 0.6,
});

export const fallbackText = css({
  fontSize: 'body-sm',
  fontWeight: 'regular',
  marginBottom: 'tightest',
});

export const fallbackSubtext = css({
  fontSize: 'body-xs',
  color: 'text.subtle',
});

export const footerContainer = css({
  marginTop: 'default',
});
